import { render, staticRenderFns } from "./Scrollbar.vue?vue&type=template&id=047225c2&"
import script from "./Scrollbar.vue?vue&type=script&lang=ts&"
export * from "./Scrollbar.vue?vue&type=script&lang=ts&"
import style0 from "./Scrollbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports